import { IonBackdrop, IonContent, IonPage } from '@ionic/react'
import { Footer, Header } from 'components'
import { useAcceptLanguage, useBackDrop, useJwtToken } from 'hooks'

import 'theme/main.scss'
import { motion } from 'framer-motion'
import { useState, useEffect, useContext } from 'react'
import { authContext } from 'contexts/'

interface IBasePageProps {
  bgColor?: string
  headerLogo?: string
  pageClass?: string | string[]
  paddingHeight?: number
  children?: React.ReactNode
}

const BasePage: React.FC<IBasePageProps> = ({ bgColor, pageClass, headerLogo, children, paddingHeight: height }) => {
  useAcceptLanguage()
  const errorRefreshToken = useJwtToken()
  const auth = useContext(authContext)
  const [menuMobileOpen, setMenuMobileOpen] = useState(false)
  const [realBodyClass, setRealBodyClass] = useState<string[]>([])
  const backDropOpen = useBackDrop()

  useEffect(() => {
    let bc: string[] = []
    if (pageClass) {
      if (typeof pageClass === 'string') bc.push(pageClass)
      else bc = [...pageClass]
    }
    if (menuMobileOpen) bc.push('menu-mobile-open')

    setRealBodyClass(bc)
  }, [pageClass, menuMobileOpen])

  const divFooterPaddingStyle = { width: '100%', height: !!height ? height + 'px' : undefined }

  if (errorRefreshToken) {
    window.location.href = '/login'
  }

  return (
    <IonPage className={realBodyClass?.length > 0 ? realBodyClass.join(' ') : undefined}>
      {backDropOpen && <IonBackdrop className="backdrop-mobile" />}
      <Header logo={headerLogo} isAuthenticated={!!auth?.user} menuMobileOpen={menuMobileOpen} setMenuMobileOpen={setMenuMobileOpen} />

      <IonContent className="main-content" scrollEvents={!menuMobileOpen && !backDropOpen} fullscreen={true}>
        {menuMobileOpen && <IonBackdrop onIonBackdropTap={() => setMenuMobileOpen((mmo) => !mmo)} className="backdrop-mobile" />}

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          style={{ minHeight: '100vh', backgroundColor: bgColor }}
        >
          {children}
        </motion.div>
        <Footer />
        {!!height && <div style={divFooterPaddingStyle} className="ion-hide-lg-up footer-padding"></div>}
      </IonContent>
    </IonPage>
  )
}

export default BasePage
